var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinie01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-01__Icn/40px/Linie-01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-01__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Linie-01__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-01__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Linie-01__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28,9.58288574 C28.5522847,9.58288574 29,10.030601 29,10.5828857 C29,11.1351705 28.5522847,11.5828857 28,11.5828857 C24.884275,11.5828857 23.4318699,12.7931136 22.2176479,16.4527316 L22.0496239,16.9793972 L21.8838313,17.5386039 L21.7194094,18.1311 L21.555498,18.7576334 L21.3912367,19.4189522 L20.8942048,21.5196638 L20.7088124,22.2619556 C20.6782456,22.3811162 20.6478149,22.4980602 20.6174751,22.612879 L20.4361667,23.2770203 C19.863196,25.3040032 19.2905188,26.6297174 18.4091087,27.8804627 C16.7820336,30.1893275 14.3840511,31.401001 11,31.401001 C10.4477153,31.401001 10,30.9532857 10,30.401001 C10,29.8487162 10.4477153,29.401001 11,29.401001 C15.1302491,29.401001 16.9448089,27.7515015 18.3666134,23.1633576 L18.5424325,22.574441 C18.5714411,22.4737062 18.600314,22.3716726 18.6290686,22.2683287 L18.8003158,21.6324466 C18.8286668,21.5238143 18.8569342,21.4138483 18.8851355,21.3025368 L19.0536886,20.6184304 L19.4518362,18.9238813 L19.6975181,17.921883 L19.8537957,17.3180314 L20.0062409,16.7603357 L20.1567186,16.244371 C20.1817379,16.1616086 20.2067529,16.0804007 20.2318025,16.0006551 L20.3828259,15.5389906 L20.5365444,15.1079954 C20.7960239,14.4127697 21.0745034,13.8268963 21.4108371,13.2581937 L21.6198906,12.9182953 C23.0147679,10.7333401 25.0780175,9.58288574 28,9.58288574 Z",
    id: ".._.._src_svg_Icn_40px_Linie-01__Path-11-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinie01);
export default __webpack_public_path__ + "static/media/Linie-01.e5af831006cbe2d442cd9730de2d82ff.svg";
export { ForwardRef as ReactComponent };